import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=75f79d9e"
import script from "./tagList.vue?vue&type=script&lang=js"
export * from "./tagList.vue?vue&type=script&lang=js"
import style0 from "./tagList.vue?vue&type=style&index=0&id=75f79d9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports